import script from "./ComHuonekorttiTilatTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHuonekorttiTilatTable.vue?vue&type=script&setup=true&lang=ts"

import "./ComHuonekorttiTilatTable.vue?vue&type=style&index=0&id=a553f68a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a553f68a"]])

export default __exports__